import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { filtersConfig } from './utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';

const namespace = 'delegatedTasks';
const api = bindServices(namespace);
const fetchRoute = 'delegation/delegatedTasks';

const DelegatedTasksModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
  },
  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : `${fetchRoute}/paged`,
          params: {
            limit: pageSize,
            ...CoreQueries.delegatedTasks.paged,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: pageSize, page: payload.page },
        });
      } catch (e) {}
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: fetchRoute,
          id: payload.id,
          params: payload?.params || {},
        });
        yield put({ type: 'queryItem', payload: res });
      } catch (e) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *changeSuccess({ payload }, { put }) {
      yield put({
        type: 'querySuccess',
        payload,
      });
    },

    *resetState({ payload }, { put }) {
      yield put({
        type: 'queryResetState',
        payload,
      });
    },

    *showForm({ payload }, { put }) {
      yield put({ type: 'queryShowForm', payload });
    },

    *openView({ payload }, { put }) {
      yield put({ type: 'queryOpenView', payload });
    },
  },
  reducers: makeListReducers({
    initialPagination,
    initialState: {
      ...initialState,
      filtersConfig,
    },
  }),
};

export default DelegatedTasksModel;
